import React from "react";

/**
 * Operational marker glyph, drawn on the same 24x24 grid and weight as WrenchIcon and
 * TrafficConeIcon so the three read as one set.
 *
 * Fill is currentColor and props are spread onto the <svg> so the colour comes from
 * the wrapper's `color`.
 */
// `name` is destructured away because CustomIcon spreads its whole props
// object, which would otherwise put name="status-..." on the <svg>.
const CheckIcon = ({ size = 10, name, ...props }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            fill="currentColor"
            d="M9.2 16.6 4.6 12a1.6 1.6 0 0 0-2.26 2.26l5.73 5.73a1.6 1.6 0 0 0 2.26 0L21.66 8.66A1.6 1.6 0 0 0 19.4 6.4Z"
        />
    </svg>
);

export default CheckIcon;
